// extracted by mini-css-extract-plugin
export default {"listagem":"styles_listagem__hoytb","containerList":"styles_containerList__DL3zc"};